export const Url = {

    SIGNINWITH_EMAIL: 'admin/AdminSignIn',
    LOGIN_ROLE:'admin/admin_roles',
    ALL_LANGUAGE:'admin/all_languages',
    PGM_LIST:'admin/GetAllPgmUsers',
    PGM_DETAIL:'admin/Get_Pgm_Profile_Details',
    PGM_ROLES:'admin/pgm_roles',
    USER_APPROVAL:'admin/AdminVerification',
    USER_DEACTIVATE:'/admin/pgm_deactivate',
    NEED_CORRECTION:'admin/PgmCorrections',
    LOGOUT:'admin/AdminSignOut',
    ADD_PARTNER:'admin/UserProfile',
    CREATE_BUSINESS_CONTACT:'admin/CreateBusninessContact',
    CREATE_QUESTIONNAIRE:'admin/Questionnaire',
    QUESTIONAIRE_LIST:'admin/QuestionnaireList',
    QUESTIONNAIR_CONFIG:'admin/questionaire_config',
    ORDER_LIST:'admin/user_orders_list',
    ORDER_VIEW_LIST:'admin/get_order_details',
    SET_PASSWORD:'admin/SetPassword',
    PART_LIST:'admin/get_parts_list',
    VEHICLE_LIST:'admin/get_vehicle_module_list',
    COUNTRY_LIST:'admin/countries',
    DISTRIBUTORS_LIST:'admin/distributors',
    VERIFICATION_DOCUMENT:'admin/verification_documents',
    PART_CATELOGUE_LIST:'admin/get_part_catalogue_list',
    EDIT_PART_CATELOGUE_LIST:'admin/get_parts_catalogue_detail',
    VEHICLE_CATEGORY_LIST:'admin/get_vehicle_category_list',
    EDIT_PART:'admin/get_parts_detail',
    MODULE_LIST:'admin/get_module_list',
    DETAILS_MODULE_LIST:'admin/get_module_details',
    TUTORIAL_AND_TROUBLE:'admin/get_tutorial_list',
    CHECKED_UNCHECKED_TUTORIAL:'admin/get_selected_unselected_tutorial_list',
    ADD_CONTENT:'admin/create_tutorial',
    UPDATE_CONTENT:'admin/update_tutorial',
    EDIT_TRAINING: 'admin/tutorial',
    ADD_MODULE:'admin/create_module',
    UPDATE_MODULE:'admin/update_module',
    CRETAE_PART:'admin/create_part',
    UPDATE_PART:'admin/update_part',
    CREATE_CATALOGE:'admin/create_part_catalogue',
    UPDATE_CATALOGE:'admin/update_part_catalogue',
    CREATE_ORDER_STATUS:'admin/create_order_status',
    SECURITY_QUESTION_LIST:'admin/GetSecurityQuestionsList',
    DOWNLOAD_ORDER:'admin/download_excel_order',
    DOWNLOAD_PARTS:'admin/download_excel_parts/',
    DOWNLOAD_PARTNER:'admin/generate_pgm_list_excel',
    ADD_BULK_PART:'admin/upload_parts_excel',
    UPLOAD_BUSINESS_CONTACT_FILE:'admin/upload_business_contact_files',
    DELETE_STORE_PHOTO:'admin/delete_store_photos',
    LAT_LONG_AUTH:'admin/lat_long_auth',
    SELECT_LANGUAGE:'admin/languages',
    FORGET_PASSWORD:'admin/reset_password_mail',
    RESET_PASSWORD:'admin/reset_password',
    DOWNLOAD_ORDER_DATE_RANGE:'admin/download_excel_order_parts',
    ROLES_PERMISSION:'admin/get_permissions_list',
    GET_STATES:'admin/states',
    CREATE_ROLE:'admin/create_role_permission',
    DELETE_ROLE:'admin/delete_role_permission',
    GET_ROLE_DETAILS:'admin/get_role_permission_detail',
    UPDATE_ROLE_DETAILS:'admin/update_role_permission',
    CREATE_USER:'admin/onboard_admin_user',
    USER_LIST:'admin/admin_users',
    GET_USER_DETAILS:'admin/admin_user_details',
    DELETE_USER:'admin/delete_admin_user',
    UPDATE_USER:'admin/update_admin_user',
    CREATE_AREA_EXECUTIVE:'admin/area_executive',
    AREA_EXECUTIVE_LIST:'admin/area_executives',
    DELETE_AREA_EXECUTIVE:'admin/area_executive_delete',
    GET_AREA_EXECUTIVE_DETAILS:'admin/area_executive',
    UPDATE_AREA_EXECUTIVE:'admin/area_executive_update',
    USER_ACTIVATE_DEACTIVATE_SWITCH:'admin/admin_user/activate_deactivate',
    AREA_EXECUTIVE_ACTIVATE_DEACTIVATE_SWITCH:'admin/area_executive/activate_deactivate',
    GET_GROUP_DATA:'admin/discount_groups',
    UPDATE_DISCOUNT_GROUP:(id)=>`admin/pgm_user/${id}/discount_group`,
    GET_NOTIFICATION_SCHEDULE_LIST:'admin/schedule_notifications',
    CREATE_NOTIFICATION_SCHEDULE:'admin/schedule_notification',
    UPDATE_SCHEDULE_NOTIFICATION:'admin/schedule_notification_update',
    GET_DETAIL_SCHEDULE_NOTIFICATION:'admin/schedule_notifications',
    GET_USER_GROUP:'admin/user_group',
    GET_REDIRECTION_PAGE:'admin/redirection_page',
    DOWNLOAD_NOTIFICATION_EXCEL:'admin/schedule_notification_download'
  }

export const MEXICO_COUNTRY_CODE = process.env.REACT_APP_MEXICO_COUNTRY;
export const NIGERIA_COUNTRY_CODE = process.env.REACT_APP_NIGERIA_COUNTRY;
export const LANGUAGE = process.env.REACT_APP_LANGUAGE;
export const ADDRESS_API={
  BASE_URL:process.env.REACT_APP_ADDRESS_API_URL,
  SEARCH_LOCATION:'autocomplete.json?query=%s&access_token=%s&country=%s&lang=%s',
  DETAILED_LOCATION:'location_details?location=%.6f,%.6f8&access_token=%s&country=%s&lang=%s',
  LAT_LONG_API_GRANT_TYPE : process.env.REACT_APP_LAT_LONG_API_GRANT_TYPE,
  LAT_LONG_API_CLIENT_ID : process.env.REACT_APP_LAT_LONG_API_CLIENT_ID,
  LAT_LONG_API_CLIENT_SECRET : process.env.REACT_APP_LAT_LONG_API_CLIENT_SECRET,
  LAT_LONG_AUTH_TOKEN_ENDPOINT : 'oauth/token?grant_type=%s&client_id=%s&client_secret=%s',
}
  
  